/* eslint-disable react/react-in-jsx-scope */
import React, { useContext } from 'react';

import _get from 'lodash/get';
import noop from 'lodash/noop';

import { EMPTY_OBJECT, AppContext, ModalContext, CURRENT_ENV, ENVIRONMENT } from 'commons-ui';
import { Button } from 'baseui/button';
import { GAME_KEY_MAP } from '../utils/helper';
import useService from '../utils/useService';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT, setConfirmationDialog } = params;
	const { updateZKUpdateReq, sendZkUpdateReqOtp } = useService();
	const { app, showAlert } = useContext(AppContext);
	const { setModalConfig } = useContext(ModalContext);

	switch (action.id) {
		case 'getKeys':
			return () => {
				const { id } = rowData;

				history.push({
					pathname: '/gameAdmin/zookeeper/keys',
					state: {
						keysData: {
							serviceName: id
						}
					}
				});
			};
		case 'getAllPendingZkUpdateReqs':
			return () => {
				const { id } = rowData;

				history.push({
					pathname: '/gameAdmin/zookeeper/getAllPendingZkUpdateReqs/',
					state: {
						keysData: {
							serviceName: id
						}
					}
				});
			};
		case 'approveUpdateReq': {
			const { id, serviceName } = rowData;
			const game = GAME_KEY_MAP[app.appName];
			const sendOtp = async () => {
				const res = await sendZkUpdateReqOtp({
					serviceName,
					game,
					reqId: id
				});
				if (res?.success) {
					showAlert('OTP sent successfully', {
						type: 'success',
						actionOnClick: () => {
							history.goBack();
						}
					});
				} else {
					showAlert(`OTP send failed. ${res?.message ? res.message : ''}`, {
						type: 'error',
						actionMessage: 'OK',
						actionOnClick: () => {
							history.goBack();
						}
					});
				}

				return res.success;
			};
			const approveUpdateReq = async (otp?: number) => {
				const res = await updateZKUpdateReq({
					serviceName,
					game,
					reqId: id,
					action: 'APPROVED',
					otp
				});
				if (res?.success && !res?.isError) {
					showAlert('Key Update was Successful', {
						type: 'success',
						duration: 'INFINITE',
						actionMessage: 'OK',
						actionOnClick: () => {
							history.goBack();
						}
					});
				} else {
					showAlert(`Key Update Failed. ${res.message}`, {
						type: 'error',
						actionMessage: 'OK',
						actionOnClick: () => {
							history.goBack();
						}
					});
				}
			};

			return () => {
				if (CURRENT_ENV === ENVIRONMENT.PRODUCTION) {
					sendOtp();
					setModalConfig({
						isOpen: true,
						header: 'Please enter the OTP to approve the change',
						content: (
							<div>
								<input
									type='number'
									id='requiredValue'
									required
									style={{ width: '100%', padding: '8px', marginBottom: '16px' }}
								/>
								<Button
									onClick={() => {
										const input = document.getElementById('requiredValue') as HTMLInputElement;
										const otp = Number(input.value);
										if (!otp) {
											showAlert('Please enter a valid otp', {
												type: 'error'
											});
											return;
										}
										setModalConfig({ isOpen: false });
										setConfirmationDialog({
											show: true,
											header: 'Approve the change?',
											handleAlertConfirmation: () => approveUpdateReq(otp)
										});
									}}>
									Continue
								</Button>
							</div>
						)
					});
				} else {
					setConfirmationDialog({
						show: true,
						header: 'Approve the change?',
						handleAlertConfirmation: () => approveUpdateReq()
					});
				}
			};
		}

		case 'rejectUpdateReq': {
			const { id, serviceName } = rowData;
			const game = GAME_KEY_MAP[app];
			const approveUpdateReq = async () => {
				const res = await updateZKUpdateReq({
					serviceName,
					game,
					reqId: id,
					action: 'REJECTED'
				});
				if (res?.success) {
					showAlert('Key Reject was Successful', {
						type: 'success',
						duration: 'INFINITE',
						actionMessage: 'OK',
						actionOnClick: () => {
							history.goBack();
						}
					});
				} else {
					showAlert(`Key Reject Failed. ${res.message}`, {
						type: 'error',
						actionMessage: 'OK',
						actionOnClick: () => {
							history.goBack();
						}
					});
				}
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Reject the change?',
					handleAlertConfirmation: approveUpdateReq
				});
			};
		}

		case 'viewKey':
			return () => {
				const { id, serviceName } = rowData;
				history.push({
					pathname: '/gameAdmin/zookeeper/edit',
					state: {
						keysData: {
							serviceName,
							keyName: id
						}
					}
				});
			};
		case 'addKey':
			return () => {
				const { serviceName } = _get(params, 'location.state.keysData', {});
				history.push({
					pathname: '/gameAdmin/zookeeper/add',
					state: {
						keysData: {
							serviceName
						}
					}
				});
			};

		default:
			return noop;
	}
};

export default {
	makeActionHandler
};
